import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Player} from '../../shared/models/player';
import {
  ChangePlayersPageSizeAction,
  LoadPlayersSuccessAction,
  OrderPlayersByAction,
  PagePlayersToAction,
  playerListActionTypes,
  QuickSearchPlayersAction, SearchPlayersAction, TogglePlayersSelectionAction,
  ToggleSearchPlayersAction
} from '../actions/players-list';
import {DEFAULT_PAGE_SIZE} from '../../shared';
import {PlayerFilter, SelectedPlayers} from '../models/player-filter';
import {removePlayerActionTypes} from '../actions/remove-player';
import {siteAssignPlayerActionTypes, SiteAssignPlayerSuccessAction} from '../actions/site-assign-player';
import { defaultPlayerActionTypes } from '../actions/default-player';

export interface PlayersState {
  array: Player[];
  showFilter: boolean;
  quickSearch: string;
  filter: PlayerFilter;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
  selectedPlayer: SelectedPlayers[];
}

const initialState: PlayersState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'updated descending',
  count: 0,
  selectedPlayer: [],
};

export function PlayersReducer(state: PlayersState = initialState, action: Action): PlayersState {
  switch (action.type) {
    case playerListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case playerListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case playerListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case playerListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case playerListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case playerListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case removePlayerActionTypes.REMOVE_SELECTION_PLAYER:
    case defaultPlayerActionTypes.DEFAULT_SELECTION_PLAYER:
      return handlePlayerSelectionAction(state, action);
    case playerListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case playerListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case playerListActionTypes.CLEAR:
      return handleLoadClearActions();
    case siteAssignPlayerActionTypes.ADD_SUCCESS:
      return handleUpdateAssignPlayer(state, action);
    default:
      return state;
  }
}

function handleToggleSearchAction(state: PlayersState, action: ToggleSearchPlayersAction): PlayersState {
  const newState: PlayersState = {
    ... state,
    showFilter: action.payload,
    selectedPlayer: []
  };
  return newState;
}

function handleQuickSearchAction(state: PlayersState, action: QuickSearchPlayersAction): PlayersState {
  const newState: PlayersState = {
    ... state,
    quickSearch: action.payload,
    page: 1,
    selectedPlayer: []
  };
  return newState;
}

function handleSearchAction(state: PlayersState, action: SearchPlayersAction): PlayersState {
  const newState: PlayersState = {
    ... state,
    filter: action.payload,
    page: 1,
    selectedPlayer: []
  };
  return newState;
}

function handlePageToAction(state: PlayersState, action: PagePlayersToAction): PlayersState {
  const newState: PlayersState = {
    ... state,
    page: action.payload,
    selectedPlayer: []
  };
  return newState;
}

function handleLoadSuccessAction(state: PlayersState, action: LoadPlayersSuccessAction): PlayersState {
  const newState: PlayersState = {
    ... state,
    array: action.payload.array,
    selectedPlayer: []
  };
  return newState;
}

function handlePlayerSelectionAction(state: PlayersState, action: TogglePlayersSelectionAction): PlayersState {
  const selectedIndex = _.findIndex(state.selectedPlayer, ['deviceID', action.payload.deviceID]);
  let selected: SelectedPlayers[];
  if (selectedIndex > -1) {
    selected =  state.selectedPlayer;
  } else {
    const player = _.find(state.array, u => u.deviceID === action.payload.deviceID);
    const selectedPlayer: SelectedPlayers = {deviceID: player.deviceID , isDefault: player.isDefault ,
                                             subscriptionUuid: player.subscription ? player.subscription.uuid : null};
    selected = [selectedPlayer];
  }

  const newState: PlayersState = {
    ... state,
    selectedPlayer: selected
  };
  return newState;
}

function handleChangePageSizeAction(state: PlayersState, action: ChangePlayersPageSizeAction): PlayersState {
  const newState: PlayersState = {
    ... state,
    page: 1,
    pageSize: action.payload,
    selectedPlayer: []
  };
  return newState;
}
function handleOrderByAction(state: PlayersState, action: OrderPlayersByAction): PlayersState {
  const newState: PlayersState = {
    ... state,
    orderBy: action.payload,
    selectedPlayer: []
  };
  return newState;
}

function handleLoadClearActions(): PlayersState {
  const newState: PlayersState = {
    array: undefined,
    showFilter: false,
    quickSearch: undefined,
    filter: undefined,
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    orderBy: 'updated descending',
    count: 0,
    selectedPlayer: [],
  };
  return newState;
}

function handleLoadErrorActions(state: PlayersState): PlayersState {
  return state;
}

/**
 * verifie qu il n y ai qu'un seul player par default.
 * Ajoute le player et garde les données ordonnées.
 * @param state
 * @param action
 */
function handleUpdateAssignPlayer(state: PlayersState, action: SiteAssignPlayerSuccessAction): PlayersState {
  let arrayPlayer = state.array;
  if (action.payload.isDefault) {
    arrayPlayer = state.array.map((player: Player) => {
      return { ...player, ...{ isDefault: false } }
    });
  }
  const r = _.sortBy([...arrayPlayer, ...[action.payload]], [(state.orderBy).split(' ')[0]]);
  return { ...state, ...{ array: (state.orderBy).split(' ')[1] === 'descending' ? r.reverse() : r } };
}

export const playersSelectors = {
  showFilter: (state: PlayersState) => _.get(state, 'showFilter', false),
  quickSearch: (state: PlayersState) => _.get(state, 'quickSearch'),
  filter: (state: PlayersState) => _.get(state, 'filter'),
  page: (state: PlayersState) => _.get(state, 'page', 1),
  pageSize: (state: PlayersState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: PlayersState) => _.get(state, 'orderBy'),
  array: (state: PlayersState) => _.get(state, 'array', []),
  count: (state: PlayersState) => _.get(state, 'count', 0),
  selectedPlayer: (state: PlayersState) => _.get(state, 'selectedPlayer', [])
};
